import React from 'react';
import { connect } from "react-redux";
import { IContent, IProduct } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './ProductsHighlightsBlock.scss';

import Title from '../../Elements/Title/TitleElement';
import ProductHighlightElement from '../../Elements/ProductHighlight/ProductHighlightElement';

// @ts-ignore
import Slider from "react-slick";
import sliderConfig from './sliderConfig';
import PrevArrow from '../../Elements/Sliders/PrevArrow';
import NextArrow from '../../Elements/Sliders/NextArrow';
import Loader from '../../Elements/Loader/Loader';
import { cleanSpaces, getProductById } from '../../../utils';

interface IProductsHighlightsBlockProps {
  context?: IContent;
  products?: IProduct[];
}

const ProductsHighlightsBlock = ({ context, products }: IProductsHighlightsBlockProps) => {
  const { products_highlights } = context;
  const { is_active, items, title } = products_highlights;

  const isUPC = process.env.REACT_APP_ENV === "upc";

  const productsFoundInList = items
    .filter((item: any) => {
      if (isUPC) {
        return item.upc && ((item.upc.default && item.upc.default.product && item.upc.default.product.product_id) || (item.upc.fallback && item.upc.fallback.product && item.upc.fallback.product.product_id));
      } else {
        return item.web && ((item.web.default && item.web.default.product && item.web.default.product.product_id) || (item.web.fallback && item.web.fallback.product && item.web.fallback.product.product_id));
      }
    })
    .map((item: any) => isUPC ? item.upc : item.web);

  const listItems = productsFoundInList.map((item: any, index: number) => {
    const productDefault = getProductById(products, cleanSpaces(item.default.product.product_id), item.default.product.product_type);
    const productFallback = item.fallback && item.fallback.product && item.fallback.product.product_id && item.fallback.product.product_type
      ? getProductById(products, cleanSpaces(item.fallback.product.product_id), item.fallback.product.product_type)
      : null;
    return productDefault || productFallback ? (
      <ProductHighlightElement
        key={index}
        index={index}
        info={productDefault ? item.default : item.fallback}
        product={productDefault || productFallback}
      />
    ) : null;
  });

  return is_active && (
    <div className="block-products_highlights">
      {title && (
        <Title>{title}</Title>
      )}
      {!products.length ? (
        <Loader />
      ) : (
        <Slider
          className={"games"}
          {...sliderConfig}
          prevArrow={(<PrevArrow />)}
          nextArrow={(<NextArrow />)}
        >
          {listItems}
        </Slider>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  products: state.products.data
});

export default connect(mapStateToProps)(withContent(ProductsHighlightsBlock));
